import React from 'react';
import HeroPhoto from "../../Assets/top-header.png";
import { useNavigate } from 'react-router-dom';

export const Hero = () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1); // This goes back one step in history
    };

    return (
        <div
            className="relative py-10 bg-gradient-to-r z-0 from-blue-500 via-blue-600 to-blue-700 rounded-sm shadow-lg"
            style={{
                backgroundImage: `url(${HeroPhoto})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >
            <div className="absolute inset-0 bg-black bg-opacity-30 rounded-b-lg"></div>

            {/* Back Button */}
            <button
                onClick={handleGoBack}
                className="absolute top-4 left-4 z-10 flex items-center justify-center w-10 h-10 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full transition-all duration-200 shadow-md backdrop-blur-sm"
                aria-label="Go back"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
            </button>

            <div className="relative w-full px-6 py-8 z-0">
                <div className="flex flex-wrap justify-between items-start w-full flex-col">
                    <h1 className="text-3xl font-bold text-darkTextColor drop-shadow-md">
                        Hello Mr. {userData?.name}!
                    </h1>
                    <p className="mt-2 text-lg text-gray-200 drop-shadow-sm">
                        See the impact of your website with detailed statistics.
                    </p>
                </div>
            </div>
        </div>
    );
};